import { apiTransitionFauluLoan, setExpiredAuth, setLoanResultValue } from "../../../actions/fauluLoanCalculator/fauluLoanCalculatorForm";
import { getAccessToken, getDurationValue, getInterestValue, getIsApiPending, getLoanAmountValue, getRepaymentDurationValue } from "../../../selectors/fauluLoanCalculator/fauluLoanCalculator";
import axios from 'axios';

export const fauluLoanCalculatorService = (store, next, action) => {
    const result = next(action);
    const state = store.getState();

    (async () => {
            if (!getIsApiPending(store.getState())) { 
                store.dispatch(apiTransitionFauluLoan.pending());
                try {
                    const resp = await calculate(store.getState());
                    if(resp && resp.data) {
                        store.dispatch(setLoanResultValue(resp.data))
                        store.dispatch(apiTransitionFauluLoan.success());
                    } else {
                        store.dispatch(apiTransitionFauluLoan.failure());
                    }
                } catch (e) {
                    if (e?.response?.data?.status === 401 || e?.response?.data?.status === 403) {
                        store.dispatch(setExpiredAuth(true));
                        store.dispatch(apiTransitionFauluLoan.initial());
                        return;
                    } 
                    store.dispatch(setLoanResultValue(null));
                    store.dispatch(apiTransitionFauluLoan.failure());
                }
            }
        })();
    
        return result;
}

const payloadCollection = (state) => {
    const amount = getLoanAmountValue(state);
    const interest = getInterestValue(state);
    const repaymentDuration = getRepaymentDurationValue(state);
    const duration = getDurationValue(state);

    const payload = {
        loanAmount: amount.value,
        annualInterestRate: interest.value,
        termValue: repaymentDuration.value,
        termDuration: duration.value
    }

    return {
        ...payload
    }
}

const calculate = async (state) => {
    try {
        const url = '/om-api/faulu-loan-calculator/quotation';
        const loginData = getAccessToken(state);
        return await axios.post(url, payloadCollection(state), {
            headers: {
                'Content-Type': 'application/json',
                accessToken: loginData.accessToken,
            },
        });        
    } catch (e) {
        throw e;
    }
}

